var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExportCsv = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x3C_Layer_x3E_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1120.9 1377.7",
    style: {
      enableBackground: "new 0 0 1120.9 1377.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3853FA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,1082.2c-32,0-52.8-20.8-52.8-52.9c0-298.2,0-570.4,0-868.6c0-25.6,13.7-44.7,36.7-50.8 c4.6-1.2,9.5-1.7,14.3-1.7c148.3-0.1,321.7-0.1,470-0.1c1.1,0,2.3,0,4.1,0c0,100.3,0,200.9,0,300.9c100,0,166.6,0,266.9,0 c0,2.1,0,3.9,0,5.6c0,79.8,0,75.6,0,155.4l113,96.4c0-137.4,0-199.8,0-337.2c-5.7-5.6-11.4-11.2-17.1-16.8 C888,209.5,785.1,106.6,682.3,3.7c-2.2-2.2-4.2-3.7-7.7-3.7C502,0.1,322.3-0.1,149.6,0.2C73.3,0.4,9,59.9,1.8,135.9 c-0.5,5.6-0.8,11.3-0.8,17C1,451,1,749.2,1,1047.4c0,64.9,36.9,119.4,97.5,142.9c11.5,4.5,24.1,6.1,36.2,9c1.4,0.3,2.9,0.6,4.3,1 c61.3,0,82.6,0,143.9,0c7.5-31.1,18.7-83.1,35.4-118C250.1,1082.2,224,1082.2,155.8,1082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1120.9,991.4L821.7,703.1v168.6c-453.8,81.1-439,506-439,506c158.8-300.3,452.6-295.2,452.6-295.2v151 L1120.9,991.4z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExportCsv, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exportCsv.c1becf75.svg";
export { ForwardRef as ReactComponent };